exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".for-auto {\n  padding: 107px 0;\n  background: var(--light-blue);\n}\n@media only screen and (max-width: 1024px) {\n.for-auto {\n    padding: 50px 0;\n}\n}\n.for-auto_body {\n  display: grid;\n  grid-template-columns: repeat(5, 1fr);\n  gap: 30px;\n}\n@media only screen and (max-width: 1024px) {\n.for-auto_body {\n    grid-template-columns: repeat(2, 1fr);\n}\n}\n", ""]);

// exports
